import "@material/web/button/text-button";
import "@material/web/icon/icon";
import "@material/web/iconbutton/icon-button";
import "@material/web/textfield/outlined-text-field";

import { AsyncPipe, NgStyle } from "@angular/common";
import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatDialog, MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { Router } from "@angular/router";
import { map, Observable, tap } from "rxjs";

import { DataService } from "../services/data.service";
import { QPilotCloudApiService } from "../services/qpilot-cloud-api.service";
import { SiteSettingsService } from "../services/site-settings.service";
import { getCleanProductTitle } from "../utils";
import { QPilotProduct } from "../web-components/types/product";

@Component({
  selector: "app-add-product-list",
  standalone: true,
  imports: [
    MatDialogModule,
    AsyncPipe,
    FormsModule,
    NgStyle,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: "./add-product-list.component.html",
  styleUrl: "./add-product-list.component.scss",
})
export class AddProductListComponent implements OnInit {
  products$: Observable<QPilotProduct[]>;
  searchTerm = "";

  constructor(
    private qPilotCloudApiService: QPilotCloudApiService,
    protected siteSettingsService: SiteSettingsService,
    private dataService: DataService,
    private dialog: MatDialog,
    private router: Router,
  ) {}

  ngOnInit() {
    this.products$ = this.dataService.products$.pipe(
      map((products) => {
        // Ensure siteSettings is loaded before filtering
        if (!this.siteSettingsService.siteSettings) {
          // Return an empty array or the original products based on your needs
          // to avoid errors before settings are loaded
          return products;
        }
        if (this.siteSettingsService.siteSettings.hideOutOfStockProducts) {
          return products.filter(
            (product) => product.availability === "InStock",
          );
        }
        return products;
      }),
    );
  }

  search(): void {
    this.products$ = this.qPilotCloudApiService
      .getProducts(this.searchTerm)
      .pipe(
        map((data) => {
          let products = data.items;
          if (this.siteSettingsService.siteSettings.hideOutOfStockProducts) {
            products = products.filter(
              (product) => product.availability === "InStock",
            );
          }
          return products;
        }),
        tap((data) => this.dataService.setProducts(data)),
      );
  }

  onSearchInput(event: Event): void {
    this.searchTerm = (event.target as HTMLInputElement)?.value ?? "";
  }

  operateProduct(product: QPilotProduct): void {
    void this.router.navigate(
      [{ outlets: { dialog: ["add-products", product.id] } }],
      { skipLocationChange: true },
    );
  }

  goBack(): void {
    this.dialog.closeAll();
  }

  getItemBackgroundImage(product: QPilotProduct): object {
    return {
      backgroundImage: `url("${product.imageUrl ?? product?.metadata?.imageUrl ?? product?.metadata?.imageThumbUrl ?? ""}")`,
    };
  }

  getCleanProductTitle = getCleanProductTitle;
}
